up.compiler('.reload--drag', (element) => {
  let startY = 0;
  let isAtTop = false;
  let reloading = false;
  const threshold = 200;
  const circumference = 2 * Math.PI * 18;
  
  const spinner = document.getElementById('reload-spinner');
  const bgCircle = document.getElementById('reload-bg-circle');
  const progressCircle = document.getElementById('reload-progress');
  const reloadPath = document.getElementById('reload-icon');
  const reloadParent = element.parentElement;
  
  function setProgress(percent) {
    if (progressCircle) {
      progressCircle.style.strokeDashoffset = circumference * (1 - percent);
    }
    if (spinner) {
      spinner.style.transform = `translateX(-50%) scale(${percent > 0 ? 1 : 0})`;
    }
  }

  window.addEventListener('touchstart', function(e) {
    if (window.scrollY === 0) {
      isAtTop = true;
      startY = e.touches[0].clientY;
      setProgress(0);
    } else {
      isAtTop = false;
      setProgress(0);
    }
  });

  window.addEventListener('touchmove', function(e) {
    if (isAtTop) {
      let currentY = e.touches[0].clientY;
      let drag = Math.max(0, Math.min(currentY - startY, threshold));
      let percent = drag / threshold;
      setProgress(percent);

      if (percent === 1) {
        reloading = true;

        if (spinner) spinner.style.animation = "spin 1s linear infinite";
        if (bgCircle) bgCircle.style.display = "none";
        if (progressCircle) progressCircle.style.display = "none";

        if(reloadParent) reloadParent.style.marginTop = threshold/2 + 'px';
        spinner.style.top = threshold/2 + 'px';

        reloadPath.style.display = 'block';
        setTimeout(() => {
          location.reload();
        }, 500);
        isAtTop = false;
      }
    }
  });

  window.addEventListener('touchend', function(e) {
    if(!reloading) setProgress(0);
  });
});
